var map = {
	"./all.svg": 89259,
	"./arrowDownGrayIcon.svg": 38870,
	"./arrowDownIcon.svg": 57204,
	"./arrowDownSmallIcon.svg": 87111,
	"./arrowLeftIcon.svg": 37994,
	"./arrowRightWhiteIcon.svg": 48565,
	"./arrowUpGrayIcon.svg": 33810,
	"./basketIcon.svg": 28564,
	"./betIcon.svg": 68093,
	"./blueArrowIcon.svg": 255,
	"./bonusBuy.svg": 57750,
	"./btc.svg": 62893,
	"./burgerIcon.svg": 20933,
	"./casinoIcon.svg": 80162,
	"./casual.svg": 27718,
	"./categoryDefault.svg": 6667,
	"./checkIcon.svg": 5557,
	"./clockIcon.svg": 21162,
	"./closeIcon.svg": 83508,
	"./crossCircleIcon.svg": 61912,
	"./crossGrayIcon.svg": 4909,
	"./crossIcon.svg": 24209,
	"./crossInCircleIcon.svg": 14535,
	"./crossWhiteIcon.svg": 35761,
	"./cup.svg": 26405,
	"./currencyIcon.svg": 96451,
	"./dropdownArrow.svg": 17810,
	"./envelopeIcon.svg": 42066,
	"./equalitySign.svg": 21634,
	"./errorIcon.svg": 53837,
	"./eyeClosedIcon.svg": 25831,
	"./eyeOpenIcon.svg": 71313,
	"./globeIcon.svg": 84592,
	"./grayBetIcon.svg": 53919,
	"./greyHeartIcon.png": 66385,
	"./heartFullIcon.svg": 41515,
	"./heartIcon.svg": 6691,
	"./heartIconDouble.svg": 31684,
	"./homeIcon.svg": 20231,
	"./homeStrokeIcon.svg": 83578,
	"./infoIcon.svg": 66544,
	"./infoIconCircle.svg": 8525,
	"./infoIconTooltip.svg": 30057,
	"./jackpot.svg": 93388,
	"./jackpotIcon.png": 37767,
	"./live.svg": 36875,
	"./lockIcon.svg": 66332,
	"./logo.svg": 86925,
	"./logoMin.svg": 55205,
	"./lupIcon.svg": 87817,
	"./lupIcon1.svg": 16243,
	"./magnifier.svg": 3670,
	"./magnifierLargeIcon.svg": 18432,
	"./menuIcon.svg": 84568,
	"./minusIcon.svg": 46101,
	"./moneyBag.svg": 27610,
	"./new.svg": 90826,
	"./newIcon.png": 94209,
	"./newNotificationIcon.svg": 13791,
	"./notificationIcon.svg": 63482,
	"./notificationWithBadgeIcon.svg": 17230,
	"./playIcon.svg": 37807,
	"./plusIcon.svg": 20686,
	"./plusIconBlack.svg": 22402,
	"./plusIconBoldWhite.svg": 66562,
	"./plusIconGrey.svg": 87701,
	"./presentIcon.svg": 34479,
	"./presentSmallIcon.svg": 57132,
	"./prizeIcon1.svg": 1070,
	"./prizePoolBlackIcon.svg": 41508,
	"./prizePoolIcon.svg": 55288,
	"./profileIcon.svg": 10385,
	"./providers1Icon.svg": 83842,
	"./providersIcon.svg": 98098,
	"./randomizeIcon.svg": 9249,
	"./searchGrayIcon.svg": 37171,
	"./searchIcon.svg": 30266,
	"./slots.svg": 70576,
	"./spinsIcon.svg": 22135,
	"./sportsIcon.svg": 74717,
	"./successCircleIcon.svg": 84874,
	"./successIcon.svg": 92509,
	"./supportIcon.svg": 81645,
	"./table.svg": 5884,
	"./termsAndConditionsIcon.svg": 38775,
	"./tickCircleDeclineIcon.svg": 33794,
	"./tickCircleIcon.svg": 3397,
	"./tickCircleIcon1.svg": 36000,
	"./tickIcon.svg": 16769,
	"./tickIcon1.svg": 18693,
	"./topicsIcon.svg": 33189,
	"./trending.svg": 27709,
	"./trendingIcon.png": 37263,
	"./wagerIcon.svg": 4888,
	"./warningIcon.svg": 4053,
	"./whiteArrowRight.svg": 50415,
	"./whiteInfoIcon.svg": 90991,
	"./withdrawalIcon.svg": 8201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64701;